import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stepper, Step, StepLabel, Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const getColor = (wait) => {
  if (wait < 10) return 'green';
  if (wait < 30) return 'orange';
  return 'red';
};

const getTripColor = (wait) => {
  if (wait < 30) return 'green';
  if (wait < 60) return 'orange';
  return 'red';
};

const TripTimeline = ({ trip }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: isMobile ? '100%' : 'calc(100vw - 200px)',
        marginBottom: 6,
        overflowX: 'auto',
      }}
    >
      <Typography
        variant="h6"
        align="center"
        gutterBottom
        sx={{ color: getTripColor(trip[0].TripDurationMinutes), fontSize: isMobile ? '1rem' : '1.25rem' }}
      >
        {t('driverName')}: {trip[0].DriverName} | {t('tripNo')}: {trip[0].TripNo} | {t('tripDuration')} {trip[0].TripDurationFormatted}
      </Typography>

      <Stepper alternativeLabel orientation="horizontal">
        {trip.map((step, index) => (
          <Step key={index} completed>
            <StepLabel
              StepIconProps={{ style: { color: getColor(step.WaitMinutes) } }}
            >
              <div dir="rtl" style={{ textAlign: 'center' }}>
                <Typography variant="body2" fontWeight="bold">{step.StationName}</Typography>
                <Typography variant="caption">
                  {new Date(step.EnterTime).toLocaleTimeString()} - {new Date(step.LeaveTime).toLocaleTimeString()}
                </Typography>
                <br />
                <Typography variant="caption" color="text.secondary">
                  {step.WaitMinutes} دقيقة
                </Typography>
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default TripTimeline;
